import React from 'react';
import { Database } from 'lucide-react';

// Supabase kaldırıldı - Bu component artık kullanılmıyor
// Backend API kullanılıyor

const SupabaseSetup = ({ onSetupComplete }) => {
  // Direkt olarak setup complete çağır
  React.useEffect(() => {
    if (onSetupComplete) {
      onSetupComplete();
    }
  }, [onSetupComplete]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 py-12 px-4">
      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-8">
          <Database className="mx-auto h-20 w-20 text-blue-600 dark:text-blue-400 mb-6" />
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">Backend API Kullanılıyor</h1>
          <p className="text-xl text-gray-600 dark:text-gray-300">Supabase kaldırıldı, Backend API kullanılıyor...</p>
        </div>
      </div>
    </div>
  );
};

export default SupabaseSetup;
